// import React from "react";
// import {
//   Briefcase,
//   FileText,
//   ClipboardList,
//   Users,
//   Mail,
//   Image,
//   Home,
//   Truck,
//   CalendarCheck,
//   LayoutDashboard,
//   WashingMachine,
//   SquareBottomDashedScissors,
//   MapPinHouse,
//   ChartCandlestick,
//   Blocks,
//   FireExtinguisher,
//   Droplet,
// } from "lucide-react";
// import Navbar from "./Navbar";
// import { FaWater } from "react-icons/fa";

// const services = [
//   {
//     title: "Medichart",
//     description:
//       "Securely manage patient records, prescriptions, and appointments in one digital platform.",
//     icon: <ClipboardList className="icon" />,

//   },
//   {
//     title: "RedCarpet",
//     description:
//       "Premium healthcare booking system with priority appointments and a VIP experience.",
//     icon: <CalendarCheck className="icon red" />,
//   },
//   {
//     title: "OrderEasy",
//     description:
//       "Smart ordering and inventory solution for pharmacies and medical stores.",
//     icon: <Truck className="icon green" />,
//   },
//   {
//     title: "MediScan",
//     description:
//       "Effortless scan booking and report delivery for diagnostic labs and patients.",
//     icon: <FileText className="icon purple" />,
//   },
//   {
//     title: "Cylinder Management",
//     description:
//       "Track and manage oxygen/gas cylinders with alerts and refill reminders.",
//     icon: <LayoutDashboard className="icon orange" />,
//   },
//   {
//     title: "Human Resource Management System",
//     description:
//       "Automate attendance, payroll, and performance tracking for hospital staff.",
//     icon: <Users className="icon yellow" />,
//   },
//   {
//     title: "Realitify",
//     description:
//       "List or discover healthcare spaces like clinics and labs with ease.",
//     icon: <Home className="icon cyan" />,
//   },
//   {
//     title: "Invoice",
//     description:
//       "Create, send, and track professional invoices with automated tax and reminders.",
//     icon: <Briefcase className="icon pink" />,
//   },
//   {
//     title: "ImageExcel",
//     description:
//       "Convert scanned medical records into editable Excel files using OCR.",
//     icon: <Image className="icon indigo" />,
//   },
//   {
//     title: "BulkEmail",
//     description:
//       "Send bulk emails with smart campaigns and analytics for healthcare outreach.",
//     icon: <Mail className="icon lime" />,
//   },
//   {
//     title: "CRM Laundry ",
//     description:
//       "A complete custiomer relatioship management solution designed specifically for laundry businesses to manage customers, orders, billing, and delivery tracking",
//     icon: <WashingMachine className="icon green" />,
//   },
//   {
//     title: "CRM Car Wash",
//     description:
//       "OrderEasy makes dining faster and smoother. Just scan the QR code, pick your restaurant, browse the menu, and place your order—all from your phone. No more waiting in lines to order. Simple, smart, and queue-free.",
//     icon: <FaWater className="icon lime" />,
//   },
//   {
//     title: "CRM Saloon ",
//     description:
//       "OrderEasy makes dining faster and smoother. Just scan the QR code, pick your restaurant, browse the menu, and place your order—all from your phone. No more waiting in lines to order. Simple, smart, and queue-free.",
//     icon: 
//     <SquareBottomDashedScissors className="icon purple"/>
//     // <GlassWater className="icon lime" />,
//   },
//   {
//     title: "CRM Real Estate ",
//     description:
//       "With Realtify, real estate agencies can streamline property management, employee assignments, and client interactions. Easily manage and track properties, assign tasks to employees, and keep an eye on all transactions,",
//     icon: 
//     <MapPinHouse className="icon orange" />
//     // <ServerCog className="icon lime" />,
//   },
//   {
//     title: "HRMSM Our Prices ",
//     description:
//       "Our system addresses the complex challenges of cylinder inventory management in godowns, making tracking and record-keeping simple and efficient.",
//     icon:
//     <ChartCandlestick className="icon yellow"/>
//     //  <ServerCog className="icon lime" />,
//   },
//   {
//     title: "HRMSM Kidz ",
//     description:
//       ".HRMS - Kidz is a smart and efficient Human Resource Management System tailored for educational institutes to manage student attendance and movements..",
//     icon: 
//     <Blocks  className="icon cyan"/>
//     // <ServerCog className="icon lime" />,
//   },
//   {
//     title: "Cylinder Management ",
//     description:
//       ".Simplify your cylinder inventory tracking, streamline warehouse operations, and manage your entire supply chain from a single platform..",
//     icon:
//     <FireExtinguisher className="icon pink"/>
//     //  <ServerCog className="icon lime" />,
//   },
//   {
//     title: "Water Jars Management  ",
//     description:
//       ".The Bottle Management System is a custom-built solution designed to efficiently manage and track the movement of bottles across different stages — including sending, receiving, and inventory history.",
//     icon: 
//     <Droplet className="icon indigo" />
//     // <ServerCog className="icon lime" />,
//   },
// ];

// const Products = () => {
//   return (
//     <>
//       <Navbar />
//       <div className="video-container">
//         <video autoPlay loop muted playsInline>
//           <source
//             src="https://cdn.pixabay.com/video/2020/08/12/46965-449623750_large.mp4"
//             type="video/mp4"
//           />
//         </video>
//       </div>
//       .{/* Hero Section */}
//       <section className="hero">
//         <div className="containerrr">
//           <div className="text-center">
//             <h1 className="hero-title">For Products:</h1>
//             <p className="hero-subtitle">
//               "Smart Industry-Specific Products That Simplify Business"
//               Ready-to-use software for Laundry, Salons, Schools, Healthcare,
//               Real Estate & more.
//             </p>
//           </div>
//         </div>
//       </section>
//       <div className="services-page">
//         {/* <h1 className="title">Our Premium Services</h1> */}
//         <div className="services-grid">
//           {services.map((service, index) => (
//             <div key={index} className="service-card">
//               <div className="icon-container">{service.icon}</div>
//               <h2 className="service-title">{service.title}</h2>
//               <p className="service-description">{service.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>


//       <style>
//         {`
//        .services-page {
//   background: linear-gradient(to bottom right, #f0f4ff, #ffffff);
//   min-height: 100vh;
//   padding: 60px 20px;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
// }


// /* Heading */
// .title {
//   text-align: center;
//   font-size: clamp(2rem, 5vw, 3rem);
//   font-weight: bold;
//   color:rgb(36, 92, 222);
//   margin-bottom: 40px;
// }

// /* Grid Layout */
// .services-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 30px;
//   max-width: 1400px;
//   margin: 0 auto;
// }

// /* Card Styling */
// .service-card {
//   background-color: #ffffff;
//   padding: 25px;
//   border-radius: 16px;
//   box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
//   border: 1px solid #e0e7ff;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;
// }

// .service-card:hover {
//   transform: translateY(-5px);
//   box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
// }

// /* Icon Styling */
// .icon-container {
//   margin-bottom: 15px;
// }

// .icon {
//   width: 36px;
//   height: 36px;
//   color: #2563eb;
// }

// .icon.red { color: #ef4444; }
// .icon.green { color: #10b981; }
// .icon.purple { color: #8b5cf6; }
// .icon.orange { color: #f97316; }
// .icon.yellow { color: #facc15; }
// .icon.cyan { color: #06b6d4; }
// .icon.pink { color: #ec4899; }
// .icon.indigo { color: #6366f1; }
// .icon.lime { color: #84cc16; }

// /* Text Styling */
// .service-title {
//   font-size: 1.4rem;
//   font-weight: 600;
//   color: #1f2937;
//   margin-bottom: 10px;
// }

// .service-description {
//   font-size: 1rem;
//   color: #4b5563;
//   line-height: 1.5;
// }












//         `}
//       </style>
//     </>
//   );
// };

// export default Products;
import React from "react";
import {
  Users, LayoutDashboard, Briefcase, CalendarCheck, Building2,
  ShoppingCart,
  Megaphone,
  Car,
  Truck,
  ClipboardList,
  GraduationCap
} from "lucide-react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";

export const productSuites = [
  {
    title: "HRMS",
    description:
      "A complete solution management solutions for organizations, hospitals and institutions.",
    feature: [
      "AI-Based Face Recognisation",
      "Employee management",
      "HR operatons",
      "Payroll & Attendance",
      "Task assignment",
      "Recruitment",
    ],
    color: "blue",
    icon: <Users size={42} />,
    link: "https://hrmsm.com/home",
  },
  {
    title: "AI FaceTrack",
    description:
      "AI-powered attendance, monitoring and smart security systems.",
    feature: [
      "AI Face Attendance",
      "Students Tracking",
      "Daily/Monthly analytics",
      "Dynamic admin dashboard",
      "Persnolised student dashboard",
      "Persnolised teacher dashboard",
    ],
    color: "purple",
    icon: <LayoutDashboard size={42} />,
    link: "/aifacetrack",
  },
  {
    title: "CRM",
    description:
      "Industry-specific Coustomer Relationship Maanagement (CRM) systems to manage customers, sales and operations efficiently.",
    feature: [
      "Hospitality CRM",
      "Finance & Insurance CRM",
      "Manufacturing CRM",
      "CRM Real Estate",
      "Retail CRM",
      "Automobile CRM"
    ],
    color: "green",
    icon: <Briefcase size={42} />,
    link: "/crm",
  },
  {
    title: "QMS",
    description:
      "Smart appointment and queue management systems (QMS) for hospitals, restaurants & billing counters.",
    feature: [
      "Resolving queue",
      "Appointments management",
      "Live token display",
      "Live order Tracking",
      "Paperless orders",
    ],
    color: "orange",
    icon: <CalendarCheck size={42} />,
    link: "/qms",
  },
  {
    title: "ERP",
    description:
      "Integrated ERP platform for streamlined business operations and resource management.",
    feature: [
      "Financial Management",
      "Inventory Management",
      "Asset Management",
      "Business Analytics",
      "Workflow Automation",
      "Procurement Management"
    ],
    color: "orange",
    icon: <Building2 size={42} />,
    link: "/contactus",
  },
  {
    title: "POS",
    description:
      "Smart Point of Sale (POS) system designed for retail stores, restaurants, supermarkets, and multi-location businesses.",
    feature: [
      "Billing & Invoicing",
      "Inventory Tracking",
      "Multi-Store Management",
      "Barcode Integration",
      "Customer Loyalty Programs",
      "Sales Analytics"
    ],
    color: "blue",
    icon: <ShoppingCart size={42} />,
    link: "/contactus",
  },
  {
    title: "M Automation",
    description:
      "Advanced Marketing Automation platform to automate campaigns, customer engagement, lead nurturing, and business growth.",
    feature: [
      "Email Marketing Automation",
      "WhatsApp Campaigns",
      "Lead Nurturing",
      "Customer Segmentation",
      "Campaign Analytics",
      "AI Marketing Insights"
    ],
    color: "purple",
    icon: <Megaphone size={42} />,
    link: "/contactus",
  },
  {
    title: "VMS",
    description:
      "Comprehensive Vendor Management System (VMS) for enterprises, manufacturing, procurement, retail, government organizations, and supply chain operations.",
    feature: [
    "Vendor Registration & Onboarding",
    "Vendor Approval Workflow",
    "Purchase Order (PO) Management",
    "Contract & Agreement Management",
    "Invoice & Payment Tracking",
    "Vendor Performance Analytics",
    ],
    color: "green",
    icon: <Users size={42} />,
    link: "/contactus",
  },
  {
    title: "DMS",
    description:
      "AI-powered Dealer Management System (DMS) for automotive dealerships, service centers, and vehicle sales operations.",
    feature: [
      "Vehicle Inventory",
      "Booking & Delivery",
      "Workshop Management",
      "Spare Parts Management",
      "Service History",
      "AI Dealer Analytics"
    ],
    color: "green",
    icon: <Car size={42} />,
    link: "/contactus",
  },
  {
    title: "Supply & Logistics",
    description:
      "End-to-end Supply Chain & Logistics Management solution for efficient movement of goods and resources.",
    feature: [
      "Shipment Tracking",
      "Warehouse Management",
      "Route Optimization",
      "Order Fulfillment",
      "Logistics Analytics"
    ],
    color: "blue",
    icon: <Truck size={42} />,
    link: "/contactus",
  },
  {
    title: "Task Allocation",
    description:
      "Intelligent Task Allocation and Workforce Management platform for organizations and project teams.",
    feature: [
      "Smart Task Assignment",
      "Team Collaboration",
      "Workload Management",
      "Project Tracking",
      "Productivity Analytics",
      "Performance Monitoring"
    ],
    color: "purple",
    icon: <ClipboardList size={42} />,
    link: "/contactus",
  },
  {
    title: "LMS",
    description:
      "Modern Learning Management System (LMS) for schools, colleges, training institutes, and corporate learning.",
    feature: [
      "Course Management",
      "Online Assessments",
      "Performance Tracking",
      "Live Classes",
      "Certificates & Reports",
      "AI Learning Recommendations"
    ],
    color: "orange",
    icon: <GraduationCap size={42} />,
    link: "/contactus",
  },

];

const Products = () => {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="hero">
        <h1 className="hero-title">Our Product Ecosystem</h1>
        <p className="hero-subtitle">
          Powerful, industry-focused software suites designed to simplify
          operations, automate workflows, and accelerate business growth.
        </p>
      </section>

      {/* Product Suites — infinite auto-scroll */}
      <section className="suite-scroller-section">
        <div className="suite-scroll-wrapper">
          <div className="suite-scroll-track">
            {[...productSuites, ...productSuites].map((suite, index) => (
              <div key={index} className={`suite-card ${suite.color}`}>
                <div className={`suite-icon suite-icon-${suite.color}`}>{suite.icon}</div>
                <h2>{suite.title}</h2>
                <p>{suite.description}</p>
                <ul>
                  {suite.feature.map((product, i) => (
                    <li key={i}>{product}</li>
                  ))}
                </ul>
                <Link to={suite.link} className="explore-btn">Explore product →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Study Button */}
      <div style={{ display: "flex", justifyContent: "center", padding: "0 20px 80px" }}>
        <Link to="/appp" className="case-study-btn">
          Case Study →
        </Link>
      </div>

      <style>{`

/* Page Background */
body {
  margin: 0;
  font-family: 'Segoe UI', sans-serif;
  background: linear-gradient(120deg, #eef2ff, #ffffff);
}

/* Hero Section */
.hero {
  text-align: center;
  padding: 100px 20px 60px;
  max-width: 900px;
  margin: auto;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: #4b5563;
  line-height: 1.7;
}

/* Scroll section */
.suite-scroller-section {
  padding: 40px 0 20px;
  background: #f9f9f9;
}

/* Overflow clip */
.suite-scroll-wrapper {
  overflow: hidden;
  position: relative;
}

/* Scrolling track — duplicated for seamless loop */
.suite-scroll-track {
  display: flex;
  gap: 30px;
  width: max-content;
  animation: suite-scroll-left 40s linear infinite;
  padding: 20px 0;
}

.suite-scroll-track:hover {
  animation-play-state: paused;
}

@keyframes suite-scroll-left {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* Cards */
.suite-card {
  background: #ffffff;
  border-radius: 22px;
  padding: 36px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
  transition: all 0.35s ease;
  border-top: 7px solid;
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.suite-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.15);
}

/* Icon Box */
.suite-icon {
  width: 70px;
  height: 70px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
}

/* Icon colors per card type */
.suite-icon-blue   { background: #eff6ff; color: #3b82f6; }
.suite-icon-purple { background: #f5f3ff; color: #8b5cf6; }
.suite-icon-green  { background: #ecfdf5; color: #10b981; }
.suite-icon-orange { background: #fff7ed; color: #f97316; }

/* Titles */
.suite-card h2 {
  font-size: 1.5rem;
  margin-bottom: 12px;
  color: #111827;
}

.suite-card p {
  color: #4b5563;
  margin-bottom: 18px;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* List */
.suite-card ul {
  list-style: none;
  padding: 0;
  margin-bottom: 24px;
  flex: 1;
}

.suite-card li {
  margin-bottom: 8px;
  color: #374151;
  font-size: 0.92rem;
  padding-left: 14px;
  position: relative;
}

.suite-card li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #10b981;
  font-weight: 700;
}

/* Button */
.explore-btn {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 10px;
  background: #111827;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  transition: background 0.3s ease;
  width: fit-content;
  margin-top: auto;
}

.explore-btn:hover {
  background: #2563eb;
}

/* Accent Colors */
.suite-card.blue   { border-color: #3b82f6; }
.suite-card.purple { border-color: #8b5cf6; }
.suite-card.green  { border-color: #10b981; }
.suite-card.orange { border-color: #f97316; }

/* Responsive */
@media (max-width: 768px) {
  .hero-title { font-size: 2.3rem; }
}
      `}</style>
    </>
  );
};

export default Products;